export default {
  isEmpty (state) {
    return Object.keys(state.data).length === 0
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/config/getters.js